<template>
  <v-dialog v-model="visible" max-width="950px" content-class="add-dev-item">
    <!--<v-btn slot="activator" color="#000000" dark class="add-button mb-2">Lisää tuote</v-btn>-->
    <v-card>
      <v-card-title class="pl-3">
        <span class="headline">{{itemId ? 'Muokkaa tehtävää' : 'Lisää tehtävä'}}</span>
      </v-card-title>
      <v-container grid-list-md class="pt-0 pb-0 ">
        
        <v-row wrap>
          <v-col cols="12" class="pb-0 mb-0">
            <v-text-field class="" v-model="newItem.name" label="Nimi" required></v-text-field>
          </v-col>
        </v-row>
        <v-row class="pb-5">
          <v-col cols="12" class="pb-0 mb-0 mt-0 pt-0">
            <span style="font-size:12px;padding-right:5px;">Valitse priority-taso: </span>
            <v-icon v-if="newItem.prio_level > 0" :size="12" @click.stop="newItem.prio_level = 1" style="padding-right:1px;color:red;">fas fa-exclamation-triangle</v-icon>
            <v-icon v-else :size="12" @click.stop="newItem.prio_level = 1" style="padding-right:1px;">fas fa-exclamation-triangle</v-icon>
            
            <v-icon v-if="newItem.prio_level > 1" :size="12" @click.stop="newItem.prio_level = 2" style="padding-right:1px;color:red;">fas fa-exclamation-triangle</v-icon>
            <v-icon v-else :size="12" @click.stop="newItem.prio_level = 2" style="padding-right:1px;">fas fa-exclamation-triangle</v-icon>
            <v-icon v-if="newItem.prio_level > 2" :size="12" @click.stop="newItem.prio_level = 3" style="padding-right:1px;color:red;">fas fa-exclamation-triangle</v-icon>
            <v-icon v-else :size="12" @click.stop="newItem.prio_level = 3" style="padding-right:1px;">fas fa-exclamation-triangle</v-icon>
            <v-icon v-if="newItem.prio_level > 3" :size="12" @click.stop="newItem.prio_level = 4" style="padding-right:1px;color:red;">fas fa-exclamation-triangle</v-icon>
            <v-icon v-else :size="12" @click.stop="newItem.prio_level = 4" style="padding-right:1px;">fas fa-exclamation-triangle</v-icon>
            <v-icon v-if="newItem.prio_level > 4" :size="12" @click.stop="newItem.prio_level = 5" style="padding-right:1px;color:red;">fas fa-exclamation-triangle</v-icon>
            <v-icon v-else :size="12" @click.stop="newItem.prio_level = 5" style="padding-right:1px;">fas fa-exclamation-triangle</v-icon>
          </v-col>
        </v-row>
        <v-row>
          <v-col :cols="contentSidebarOpen ? 74 : 12" :class="contentSidebarOpen ? 'pt-0 mt-0 pb-0 pr-0' : 'pt-0 mt-0 pb-0'">
            <div id="quill-toolbar">
              <button class="ql-bold"></button>
              <button class="ql-italic"></button>
              <button class="ql-underline"></button>
              <button class="ql-strike"></button>
              <button class="ql-list" value="ordered"></button>
              <button class="ql-list" value="bullet"></button>
              <select class="ql-header">
                <option selected></option>
                <option value="1"></option>
                <option value="2"></option>
                <option value="3"></option>
                <option value="4"></option>
                <option value="5"></option>
                <option value="6"></option>
              </select>
              <select class="ql-color"></select>
              <select class="ql-background"></select>
              <select class="ql-font"></select>
              <select class="ql-align"></select>
              <button class="ql-link"></button>
              <button class="ql-image"></button>
              <button class="ql-clean"></button>

              <button id="custom-button" @click="contentSidebarOpen = !contentSidebarOpen" style="font-size:14px;padding-top:2px;"><i class="fas fa-file-pdf"></i></button>
            </div>
            <!-- <v-textarea single-line rows=1 style="font-size:11px" :auto-grow="true" v-model="newItem.description" label="Kuvaus" required></v-textarea> -->
            <quill-editor :key="quillKey" ref="quillEditorDevItem" id="quillEditorDevItem"
              style="height:500px;padding-bottom:0px "
              v-model="newItem.description"
              :options="editorOption"
              >
            </quill-editor>
          </v-col>
          <v-col cols="5" v-if="contentSidebarOpen" class="pa-0" style="border:1px solid #ccc">
            <v-row no-gutters style="padding-top:1px;border-bottom:2px solid #ccc;background:#eee">
              <v-col cols="2" class="text-left pl-2 pt-2">
                <v-icon @click="contentSidebarOpen = false" style="" size="18" color="#111">fas fa-times</v-icon>
              </v-col>
              <v-col cols="8" class="text-center headline pt-2">
                Valitse PDF
              </v-col>
              <v-col cols="2" class="text-left pl-2"></v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <MediaUpload type="informationFile" productVariationId="" productId="" />
              </v-col>
              <v-col cols="12">
                <MediaGrid :types="['informationFile']" :actions="['delete','copyUrl','download','select']" @selectedFile="addLink" colsPerItem="3" company="" order="" product="" orderedProduct="" productVariation="" context="information" ref="mediaGrid"></MediaGrid>
              </v-col>
            </v-row>

          </v-col>
        </v-row>
        
      </v-container>
      <v-card-actions class="pt-4">
        <v-spacer></v-spacer>
        <v-btn color="avecor-button-global add-button mb-2" text @click="close">Peruuta</v-btn>
        <v-btn color="avecor-button-global add-button mb-2" text @click="addDevItem" >{{itemId ? 'Muokkaa' : 'Lisää'}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapFields } from 'vuex-map-fields'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import firebase from 'firebase'
var db = null

export default {
    props:['data'],
    components: {
      quillEditor,
    },
    data: () => ({
      autogrow:true,
      quillKey:4781500,
      contentSidebarOpen:false,
      editorOption: {
        placeholder: 'Kuvaa tähän tarkemmin miten haluaisit uuden toiminnallisuuden toimivan.',
        modules: {
          toolbar:'#quill-toolbar',
          /* toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'font': [] }],
            [{ 'align': [] }],
            ['link', 'image'],
            ['clean'],
            ['omega']
          ] */
        }
      },
      content:'',
      editedIndex: -1,
      newItem: {
        name: '',
        description:'',
        prio_level:0
      },
      defaultItem: {
        name: '',
        description:'',
        prio_level:0
      },   
    }),
    mounted() {
      db = firebase.firestore();
      if(this.itemId){
        this.newItem.name = this.data.name
        this.newItem.description = this.data.description
        this.newItem.prio_level = this.data.prio_level
      }
    },
    watch: {},
    computed: {
      ...mapFields({
        visible:"modals.development.new.visible",
        itemId:"modals.development.edit.itemId",
        staff:'staff.staff',
        settings:'settings',
        user:'user',
      }),
    },
    created () {},
    methods: {
      addLink(file){
        var quill = this.$refs['quillEditorDevItem'].quill
        quill.focus();
        var caretPosition = quill.getSelection(true);
        var text = file.name ? 'PDF - ' + file.name : 'PDF-tiedosto'
        quill.insertText(caretPosition, text, 'link', file.rawUrl);
      },
      customFormatter(date) {
        var da = dateFormat(date, "yyyy-mm-dd")
        return da
      },
      close () {
        this.visible = false
        this.itemId = ''
        setTimeout(() => {
          this.newItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      addDevItem(){
        if(this.itemId){
          const itemRef = db.collection('devItems').doc(this.itemId)
          itemRef.set({
            name:this.newItem.name,
            description:this.newItem.description,
            prio_level:this.newItem.prio_level,
            updated_at:firebase.firestore.FieldValue.serverTimestamp(),
            updated_by:this.user.uid
          }, {merge: true})  
        }
        else {
          const itemRef = db.collection('devItems').doc()
          itemRef.set({
            id:itemRef.id,  
            name:this.newItem.name,
            description:this.newItem.description,
            prio_level:this.newItem.prio_level,
            status:"upcoming",
            created_at:firebase.firestore.FieldValue.serverTimestamp(),
            created_by:this.user.uid
          }, {merge: true})
        }
        this.close()
      },
      inlineCancel () {
      },
      inlineOpen () {
      },
      inlineClose () {
        //console.log('Dialog closed')
      }
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/AddDevelopmentItem.vue